module.exports = __webpack_public_path__ + "media/images/icons/arrow-right-c45bb75fd18b19cddc6f366baed55347.svg";